
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function invoiceList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/invoice/list${queryString}`
    );
}

export async function invoiceGet(
    invoice_id: string
) {
    return await clientAxios.get(
        `admin/invoice/${invoice_id}/show`
    );
}

export async function invoiceChart(
    month: string,
    year: string,
) {
    const queryString = formatQueryString({
        month,
        year,
    });

    return await clientAxios.get(
        `admin/invoice/chart${queryString}`
    );
}

export async function invoiceDel(
    invoice_id: string
) {
    return await clientAxios.del(
        `admin/invoice/${invoice_id}/delete`
    );
}
